import { useInputPopup } from "../../InputPopup";
import BasicWidget from "@coworker/components/src/components/BasicWidget";
import { AffectedQuantityProps } from "../../InputPopup/AffectedQuantity";
import AmountIcon from "../../../assets/svg/box.svg?react";
import styled from "styled-components";
import { Trans, useTranslation } from "@coworker/locales";

const IconWrapper = styled("div")`
  svg {
    width: 25px;
    height: 25px;
  }
`;

export default function TaskFormAffectedQuantity({
  value,
  onChange,
}: AffectedQuantityProps) {
  const { getInput } = useInputPopup();
  const { t } = useTranslation();
  const valueTranslationString = `${value || 1} ${t("piecesUnit")}`;

  const getNumber = async () => {
    const response = await getInput("affectedQuantity", {
      value,
      bigTitle: <Trans>affectedQuantityString</Trans>,
    });
    if (response) {
      onChange(response);
    }
  };

  return (
    <>
      <BasicWidget
        onClick={getNumber}
        testId="affectedQuantityWidget"
        text={valueTranslationString}
        title={t("affectedQuantityString")}
        icon={
          <IconWrapper>
            <AmountIcon width={22} height={22} />
          </IconWrapper>
        }
      />
    </>
  );
}
